// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"4d241ff2","134":"24c6b07d","156":"383e39c3","241":"8bbc76e6","297":"b4e98757","495":"0eaf3b37","654":"d355e6f3","702":"218e8413","742":"86bbaf5b","766":"1f46a965","859":"04e2f973","988":"48d3f1e0"}[chunkId] + ".chunk.js";
};